(function () {
	'use strict';

	angular
		.module('app.campaignActivity')
		.controller('campaignActivityPageCtrl', ['$scope', '$rootScope', '$modal', '$stateParams',
			'campaignActivityService', 'campaignConsts',
			function ($scope, $rootScope, $modal, $stateParams, campaignActivityService, campaignConsts) {
				$scope.currentUser = $rootScope.currentUser;
				$scope.showKPIs = false;

				$scope.currentCampaign = {};
				$scope.currentInfluencer = {};
				$scope.influencerPosts = [];
				$scope.campaignActivities = [];

				$scope.viewContract = function () {
					var viewContractInfoModalScope = $rootScope.$new();
					viewContractInfoModalScope.paramsFromParent = {
						campaignId: $scope.currentCampaign.id,
						influencerId: $scope.currentInfluencer.id,
						campaignInfluencerId: $stateParams.campaign_influencer_id
					};

					var viewContractInfoModalInstance = $modal.open({
						scope: viewContractInfoModalScope,
						templateUrl: 'app/campaign/campaignViewContract/campaignViewContract.html?app_v=deployDate',
						controller: 'campaignViewContractCtrl',
					});

					$scope.viewContractInfoModalInstance = viewContractInfoModalInstance;
				}

				$scope.editCampaign = function (campaign) {
					var editCampaignModalInstance = $modal.open({
						scope: $scope,
						backdrop: 'static', // prevent closing when click outside
						templateUrl: 'app/campaign/campaignAdvertiserManagePage/campaignForm/campaignForm.html?app_v=deployDate',
						controller: 'CampaignFormCtrl'
					});

					$scope.editMode = true;
					$scope.editingCampaignId = $scope.currentCampaign.id;
					$scope.editingInfluencerId = $scope.currentInfluencer.id;
					$scope.editingCampaignInfluencerId = $stateParams.campaign_influencer_id;
					$scope.forOneInfluencer = true;
					$scope.editCampaignModalInstance = editCampaignModalInstance;
				}

				$scope.deleteInfluencer = function () {
					var deleteInfluencerModalScope = $rootScope.$new();
					deleteInfluencerModalScope.paramsFromParent = {
						campaignId: $scope.currentCampaign.id,
						influencerId: $scope.currentInfluencer.id,
						campaignInfluencerId: $stateParams.campaign_influencer_id
					};

					var deleteInfluencerModalInstance = $modal.open({
						scope: deleteInfluencerModalScope,
						templateUrl: 'app/campaign/campaignActivityPage/deleteInfluencer/campaignActivityDelete.html?app_v=deployDate',
						controller: 'campaignActivityDeleteCtrl',
					});

					$scope.deleteInfluencerModalInstance = deleteInfluencerModalInstance;
				}

				$scope.addNote = function() {
					var addNoteScope = $scope.$new();
					var addNoteModalInstance = $modal.open({
						scope: addNoteScope,
						templateUrl: 'app/campaign/campaignActivityPage/activityLogs/addNote/campaignActivityAddNote.html?app_v=deployDate',
						controller: 'campaignActivityAddNoteCtrl'
					});

					addNoteScope.campaign_influencer_id = $stateParams.campaign_influencer_id;
					addNoteModalInstance.result.then(function (result) {
						$scope.campaignActivities.unshift(result);
					});
				}

				$scope.gotoCampaignManagePage = function () {
					window.history.back();
				}

				function getCampaignInfluencerDetail() {
					campaignActivityService.getCampaignInfluencerDetail($stateParams.campaign_influencer_id)
						.then(function (campaignInfluencerResponse) {
							$scope.campaignInfluencer = campaignInfluencerResponse.data;

							if ($scope.campaignInfluencer) {
								$scope.currentCampaign = $scope.campaignInfluencer.campaign;
								$scope.currentInfluencer = $scope.campaignInfluencer.influencer;

                                $rootScope.saveParams = {
                                    project_id : $scope.currentCampaign.id,
                                    mention : 0,
                                    blog_id : 0,
                                    channel: 0,
                                    influencerGroup: 0
                                };

								$scope.showKPIs = $scope.currentCampaign.projectType === campaignConsts.Types.CAMPAIGN_CREATION;

								if ($scope.showKPIs) {
									getCampaignInfluencerGlobalKPIs();
								}

								$scope.campaignInfluencerInfo = $scope.currentInfluencer;
								$scope.campaignInfluencerInfo.campaign = $scope.currentCampaign;
								$scope.campaignInfluencerInfo.current_status = campaignActivityService.campaignStatuses.find(function (item) {
									return item.name === $scope.campaignInfluencer.status
								});
							}
						}, function (errorResponse) {
							$rootScope.handleRequestError(errorResponse, $scope);
						});
				}

				function getCampaignInfluencerGlobalKPIs() {
					campaignActivityService.getCampaignInfluencerKPIs($stateParams.campaign_influencer_id)
						.then(function (globalKpisResponse) {
							$scope.campaignInfluencerKPI = globalKpisResponse.data;
						}, function (errorResponse) {
							$rootScope.handleRequestError(errorResponse, $scope);
						});
				}

				function getCampaignInfluencerPosts() {
					campaignActivityService.getCampaignInfluencerPosts($stateParams.campaign_influencer_id)
						.then(function (influencerPostsResponse) {
							$scope.influencerPosts = influencerPostsResponse.data;
						}, function (errorResponse) {
							$rootScope.handleRequestError(errorResponse, $scope);
						});
				}

				function getCampaignActivities() {
					campaignActivityService.getCampaignActivities($stateParams.campaign_influencer_id)
						.then(function (activitiesResponse) {
							$scope.campaignActivities = activitiesResponse.data;
						}, function (errorResponse) {
							$rootScope.handleRequestError(errorResponse, $scope);
						});
				}

				getCampaignInfluencerDetail();
				getCampaignInfluencerPosts();
				getCampaignActivities();

				$scope.$on('reloadActivities', function(){
				   getCampaignActivities();
				});
			}
		])
})();
